// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1NvQ1","title":"Info_title__1SVHK","links":"Info_links__2fpFT","link":"Info_link__HUgtm","logo":"Info_logo__2xo3U"};